import StaticData from "./StaticData";

import fetchProductPage from "../graphql/queries/fetchProductPage.graphql";
import fetchAll from "../graphql/queries/fetchAll.graphql";
import fetchProductCollection from "../graphql/queries/fetchProductCollection.graphql";

export const LoadProductPage = async (client, id) => {
	if (!id.startsWith("gid://shopify/Product/")) {
		console.error("invalid product id, ignore", id);
		return;
	}
	// console.log("fetching product..", id);
	const { data, errors, extensions } = await client.request(fetchProductPage.loc.source.body, {
		variables: {
			id: id,
		},
	});

	if (errors) {
		console.error("error!", JSON.stringify(errors, null, 2));
		return;
	}

	// console.log("result!", JSON.stringify(data, null, 2), JSON.stringify(extensions, null, 2));

	return data.product;
};

const fetchCollections = async (client, id) => {
	const { data, errors, extensions } = await client.request(fetchProductCollection.loc.source.body, {
		variables: {
			id: id,
		},
	});
	if (errors) {
		console.error("error!", JSON.stringify(errors, null, 2));
		return;
	}

	// console.log("result!", JSON.stringify(data, null, 2), JSON.stringify(extensions, null, 2));

	return data.collection.products.nodes;
};

export const LoadProducts = async (client, id) => {
	switch (id) {
		case StaticData.pinURL:
			return fetchCollections(client, StaticData.getPinId());
		case StaticData.stickerURL:
			return fetchCollections(client, StaticData.getStickerId());
		case StaticData.apparelURL:
			return fetchCollections(client, StaticData.getApparelId());
		default:
		case StaticData.allURL:
			// if total products is more than 50, increase query first param
			const { data, errors, extensions } = await client.request(fetchAll.loc.source.body, { variables: { first: 50 } });
			if (errors) {
				// console.error(errors.message);
				console.error("error!", JSON.stringify(errors, null, 2));
				return;
			}
			// console.log(data.products);

			return data.products.edges;
	}
};
